import ListOfLinks from "../ListOfLinks";
import getSlugData from "../../util/getSlugData";
import { SubjectAndLevel } from "../../models/SubjectAndLevel";

function getSubjectAndLevel(link: string): SubjectAndLevel {
  const path: string[] = createSlug(link);
  return getSlugData(path);
}

function createSlug(link) {
  const path: string[] = link
    .split("/")
    // will remove any blanks or nulls
    .filter((n) => n);
  // push the first element to the end of the array (view-tutors is always the first element of this array, but getSlugData expects it after the subject and level).
  path.push(path.shift());
  return path;
}

function sanitizeString(input: string) {
  return input.replaceAll("%20", " ").replaceAll("-", " ");
}

const RelatedLinks = ({ metadata }) => {
  if (!metadata.relatedLinks?.length) {
    return null;
  }

  const links = metadata.relatedLinks.map((link) => {
    const subjectAndLevel: SubjectAndLevel = getSubjectAndLevel(link);
    const subject = sanitizeString(subjectAndLevel.subject);
    const level = sanitizeString(subjectAndLevel.level);
    return {
      name: subject + " " + level + " tutors",
      url: link,
    };
  });
  return <ListOfLinks name="Other popular tutoring subjects" links={links} />;
};

export default RelatedLinks;
